<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="26"
		height="24"
		viewBox="0 0 26 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6.29318 6C6.29318 5.58579 6.65466 5.25 7.10057 5.25H20.5354C20.9813 5.25 21.3427 5.58579 21.3427 6V18.48C21.3427 18.8943 20.9813 19.23 20.5354 19.23C20.0895 19.23 19.728 18.8943 19.728 18.48V7.81067L7.11169 19.5304C6.79639 19.8233 6.28518 19.8233 5.96988 19.5304C5.65457 19.2375 5.65457 18.7626 5.96987 18.4697L18.5862 6.75H7.10057C6.65466 6.75 6.29318 6.41421 6.29318 6Z"
			fill="white"
		/>
	</svg>
</template>
